module.exports = __webpack_public_path__ + "static/assets/83ae38124bad8c428dc02105e698fb7b.svg";